module.exports = __webpack_public_path__ + "assets/icons/Lupe-plus.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Lupe-plus.png
// module id = 530
// module chunks = 0